import { lazy } from 'react';

export const CareerHubPage = lazy(() => import('./CareerHubPage'));
